module.exports = __webpack_public_path__ + "img/embarazo.1a0d6de9.svg";